import { getMetricDisplayName, getMetricSubscript } from '@utils/metrics';
import { AUDIENCE_METRICS, Widget, WIDGET_TYPES } from '../constants';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

export const getPopoverOptions = (allowedMetrics: Record<string, any>) => {
  const allowedMetricList = [...AUDIENCE_METRICS]
    .filter(
      (metric) =>
        metric in allowedMetrics ||
        getInvertedPercentageMetricByKey({ metricKey: metric }) in allowedMetrics,
    )
    .map((metricKey) => ({
      name: metricKey,
      displayName: getMetricDisplayName({ metricKey }),
      subscript: getMetricSubscript({ metricKey }),
    }));

  // new wdgets needs to be added here as well
  return [
    WIDGET_TYPES.spi,
    WIDGET_TYPES.streams,
    WIDGET_TYPES.improvementOpportunities,
    ...allowedMetricList,
  ];
};

export const getSavedOptions = (widgets: Widget[] = [], allowedMetrics: Record<string, any>) => {
  const savedMetrics: string[] = [];
  widgets.forEach(({ widgetKey, enabled, config }) => {
    // filtering out available metrics for user
    const filteredMetrics = config.metrics.filter(
      (metric) =>
        metric in allowedMetrics ||
        getInvertedPercentageMetricByKey({ metricKey: metric }) in allowedMetrics,
    );

    // checking if widget is enabled and atleast one widget metrics available for user
    if (enabled && filteredMetrics.length) {
      if (widgetKey === WIDGET_TYPES.audienceMetrics.name) {
        savedMetrics.push(...filteredMetrics);
      } else {
        savedMetrics.push(widgetKey);
      }
    }
  });

  return savedMetrics;
};

export const isDisabled = (summaryWidgets: Widget[] = [], key: string, metricToNA: string[]) => {
  if (key in WIDGET_TYPES) {
    return summaryWidgets
      .find((widget) => widget.widgetKey === key)
      ?.config.metrics.some((metric) => metricToNA.includes(metric));
  } else {
    return metricToNA?.includes(key);
  }
};

export const areAllWidgetsNotApplicable = (summaryWidgets: Widget[] = [], metricToNA: string[]) => {
  return summaryWidgets.every((widget) =>
    widget.enabled
      ? widget.widgetKey === WIDGET_TYPES.audienceMetrics.name
        ? widget.config.metrics.every((metric) => isDisabled(summaryWidgets, metric, metricToNA))
        : isDisabled(summaryWidgets, widget.widgetKey, metricToNA)
      : true,
  );
};
